import React from 'react';

import { Burger } from '@lt/components/icons-react';
import styled from 'styled-components';

type Props = {
  openSidebar: () => void;
};

const MobileMenu = (props: Props) => {
  const { openSidebar } = props;

  return <StyledBurger onClick={openSidebar} />;
};
const StyledBurger = styled(Burger)`
  & > path {
    stroke: #c2c5cc;
  }
  width: 24px;
  height: 24px;

  position: absolute;
  right: 8px;
  bottom: 12px;
`;

export default MobileMenu;
